module.exports = __webpack_public_path__ + "static/media/coop.49860386.svg";